import { cx } from '@emotion/css';
import { useNavigate } from 'react-router';
import { useAccountSelector, useFindAccountApplicationStatus } from 'src/hooks';
import { Font, FontWeight } from 'src/styles';

import { Banner } from '../Banner/Banner';

export const AccountStatusBanner = () => {
  const navigate = useNavigate();
  const { account } = useAccountSelector();
  const { accountApplicationStatus, isAnyAccountApplicationDocumentRequested } = useFindAccountApplicationStatus();

  const findMessage = () => {
    if (accountApplicationStatus?.isRejected && isAnyAccountApplicationDocumentRequested) {
      return (
        <span className={cx(Font.h1, FontWeight.semibold)}>
          Your account has been rejected. Before we can approve your account, we will need additional information.
          Please visit{' '}
          <a
            onClick={() => {
              navigate(`/accounts/${account?.id}/account-status`);
            }}>
            Account Status
          </a>{' '}
          to submit the required information.
        </span>
      );
    }

    if (accountApplicationStatus?.isRejected) {
      return (
        <span className={cx(Font.h1, FontWeight.semibold)}>
          Your account has been rejected. You can find more information at{' '}
          <a
            onClick={() => {
              navigate(`/accounts/${account?.id}/account-status`);
            }}>
            Account Status
          </a>
          .
        </span>
      );
    }

    if (isAnyAccountApplicationDocumentRequested) {
      return (
        <span className={cx(Font.h1, FontWeight.semibold)}>
          Before we can approve your account, we will need additional information. Please visit{' '}
          <a
            onClick={() => {
              navigate(`/accounts/${account?.id}/account-status`);
            }}>
            Account Status
          </a>{' '}
          to submit the required information.
        </span>
      );
    }

    return (
      <span className={cx(Font.h1, FontWeight.semibold)} data-testid={'account-submitted-banner'}>
        Your account application has been submitted and is under review. You can find more information at{' '}
        <a
          onClick={() => {
            navigate(`/accounts/${account?.id}/account-status`);
          }}>
          Account Status
        </a>
        .
      </span>
    );
  };

  if (!account) {
    return null;
  }

  if (!accountApplicationStatus) {
    return null;
  }

  if (accountApplicationStatus.isActive) {
    return null;
  }

  return <Banner type={accountApplicationStatus.isPending ? 'warning' : 'error'} message={findMessage()} />;
};
